__turbopack_context__.v({
  "captcha": "rwFYma_captcha",
  "wrapper": "rwFYma_wrapper",
});
